import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { deleteEntity, updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/templatePagePartial/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/templatePagePartial/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/templatePagePartial/FETCH_FAILURE'

const CREATE_REQUEST = 'realhub/templatePagePartial/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/templatePagePartial/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/templatePagePartial/CREATE_FAILURE'

const UPDATE_REQUEST = 'realhub/templatePagePartial/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/templatePagePartial/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/templatePagePartial/UPDATE_FAILURE'

const DELETE_REQUEST = 'realhub/templatePagePartial/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/templatePagePartial/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/templatePagePartial/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loadedTemplatePagePartialIds: [],
  loading: false,
  result: [],
  updating: false,
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedTemplatePagePartialIds: payload.loadedTemplatePagePartialIds,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(payload = {}){
  return {
    type: CREATE_SUCCESS,
    result: payload.result,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload = {}){
  return {
    type: UPDATE_SUCCESS,
    result: payload.result,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
    result: payload.result,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function hydrateTemplatePagePartial(templatePagePartial){
  const normalizedJson = normalize(templatePagePartial, Schemas.TEMPLATE_PAGE_PARTIAL)

  return (dispatch) => {
    dispatch(updateEntities(normalizedJson))
  }
}

export function loadTemplatePagePartials(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/admin/template_page_partials.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TEMPLATE_PAGE_PARTIAL_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(normalizedJson))

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function loadTemplatePagePartial(templatePagePartialId, options){
  return (dispatch, getState) => {
    // Add Template Page ID to loaded array
    const { templatePagePartials } = getState()
    const loadedTemplatePagePartialIds = templatePagePartials.loadedTemplatePagePartialIds
      ? templatePagePartials.loadedTemplatePagePartialIds.slice()
      : []

    if (!loadedTemplatePagePartialIds.includes(templatePagePartialId)){
      loadedTemplatePagePartialIds.push(templatePagePartialId)
    }

    // Set Loading
    dispatch(fetchRequest({ loadedTemplatePagePartialIds }))

    const promise = api(`/admin/template_page_partials/${templatePagePartialId}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TEMPLATE_PAGE_PARTIAL)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(normalizedJson))

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createTemplatePagePartial(templatePagePartial, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      template_page_partial: templatePagePartial,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/template_page_partials.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TEMPLATE_PAGE_PARTIAL)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createPartialFromItem(templatePageItem, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      template_page_item_id: templatePageItem.id,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/template_page_partials/create_from_item.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TEMPLATE_PAGE_PARTIAL)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateTemplatePagePartial(templatePagePartial, options){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      template_page_partial: templatePagePartial,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/template_page_partials/${templatePagePartial.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TEMPLATE_PAGE_PARTIAL)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function duplicateTemplatePagePartial(templatePagePartial, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      template_page_partial: templatePagePartial,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/template_page_partials/${templatePagePartial.id}/duplicate.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TEMPLATE_PAGE_PARTIAL)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deleteTemplatePagePartial(templatePagePartial, options){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/template_page_partials/${templatePagePartial.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.TEMPLATE_PAGE_PARTIAL)
        dispatch(deleteEntity(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loadedTemplatePagePartialIds: action.loadedTemplatePagePartialIds || state.loadedTemplatePagePartialIds,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return { ...state, creating: true }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        result: action.result,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return { ...state, updating: true }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return { ...state, deleting: true }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        result: action.result,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
